import type { RefObject } from 'react';
import { useEffect } from 'react';
import type { PDFViewer } from 'pdfjs-dist/web/pdf_viewer.mjs';

import type { PdfFitMode } from './pdfViewerScale';

type UsePdfViewerResizeOptions = {
  containerRef: RefObject<HTMLDivElement | null>;
  viewerRef: RefObject<PDFViewer | null>;
  fitModeRef: RefObject<PdfFitMode>;
};

/**
 * Reapplies the active pdf.js fit mode when the viewer container is resized.
 */
export function usePdfViewerResize({
  containerRef,
  viewerRef,
  fitModeRef,
}: UsePdfViewerResizeOptions) {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }
    const observer = new ResizeObserver(() => {
      const viewer = viewerRef.current;
      if (viewer && fitModeRef.current) {
        viewer.currentScaleValue = fitModeRef.current;
      }
    });
    observer.observe(container);
    return () => observer.disconnect();
  }, [containerRef, fitModeRef, viewerRef]);
}
